import { Grid, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  textStyle: {
    opacity: 0.3,
    zIndex: 9998,
    "&:hover": {
      opacity: 1,
    }
  }
})

export const Footer = () => {
  const classes = useStyles();
  return (
    <Grid container sx={{ position: 'absolute', bottom: '10px', justifyContent: 'center', alignItems: 'center' }}>
      <Typography color='primary' className={classes.textStyle}>Use arrow keys in your keyboard to navigate within the frame</Typography>
    </Grid>
  )
}